class TH_Document {
    constructor() {
        this.readyStartFunctions = [];
        this.readyEndFunctions = [];
    }

    /** Add a ready start function to the document that will run on each and every page
     * 
     * @param function functionCall (the function that should be run)
     * @param array    parameters   (an array of parameters to send to the function, by default it's an empty array)
     * 
     * @returns self
     */
    addReadyStart(functionCall, parameters, name) {
        if (typeof parameters == 'undefined') parameters = [];
        if (typeof name == 'undefined') name = 'unnamed';
        this.readyStartFunctions.push({
            function: functionCall,
            parameters: parameters,
            name: name
        });

        return this;
    }

    /** Add a ready end function to the document that will run on each and every page
     * 
     * @param function functionCall (the function that should be run)
     * @param array    parameters   (an array of parameters to send to the function, by default it's an empty array)
     * 
     * @returns self
     */
    addReadyEnd(functionCall, parameters) {
        if (typeof parameters == 'undefined') parameters = [];
        
        this.readyEndFunctions.push({
            function: functionCall,
            parameters: parameters
        });

        return this;
    }

    /** Run all the functions that should be run at the beginning of document ready for ALL files in use
     * 
     */
    readyStart() {
        for (let i in this.readyStartFunctions) {
            let object = this.readyStartFunctions[i];

            object.function.apply(this, object.parameters)
        }
    }

    
    /** Run functions that should be run at the end of document ready for all pages 
     * 
     */
    readyEnd() {
        for (let i in this.readyEndFunctions) {
            let object = this.readyEndFunctions[i];

            object.function.apply(this, object.parameters)
        }
    }
}

export default TH_Document;